// Action Types
import {actionTypes} from '../action-types';

export const setMode = mode => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        mode,
      },
      type: actionTypes.STOREFRONT_SET_MODE,
    })
  );

export const addShelf = shelf => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        shelf,
      },
      type: actionTypes.STOREFRONT_ADD_SHELF,
    })
  );

export const removeShelf = shelfID => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        shelfID,
      },
      type: actionTypes.STOREFRONT_REMOVE_SHELF,
    })
  );

export const setStorefrontData = storefrontData => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        storefrontData,
      },
      type: actionTypes.STOREFRONT_SET_DATA,
    })
  );

export const createStorefront = () => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {},
      type: actionTypes.STOREFRONT_CREATE,
    })
  );

export const updateStorefront = storefrontData => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {
        storefrontData,
      },
      type: actionTypes.STOREFRONT_UPDATE,
    })
  );

export const resetStorefront = () => dispatch =>
  Promise.resolve(
    dispatch({
      payload: {},
      type: actionTypes.STOREFRONT_RESET,
    })
  );
